const API_URL = process.env.VUE_APP_API_URL
const API_REQUESTS_TIMEOUT = process.env.VUE_APP_API_REQUESTS_TIMEOUT

export default {
  API_URL,
  API_REQUESTS_TIMEOUT
}
